(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-image"] && !Shopify.designMode) return;
  try {
    // Handle lazy loading with fade-in effect
  document.addEventListener('DOMContentLoaded', function() {
    const lazyImages = document.querySelectorAll('.responsive-image img[loading="lazy"]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          
          // If image is already loaded, show it immediately
          if (img.complete) {
            img.classList.add('loaded');
          } else {
            // Otherwise wait for load event
            img.addEventListener('load', function() {
              img.classList.add('loaded');
            });
            
            // Fallback: if load event doesn't fire, show after a delay
            setTimeout(() => {
              if (!img.classList.contains('loaded')) {
                img.classList.add('loaded');
              }
            }, 1000);
          }
          
          observer.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-height-calculator"] && !Shopify.designMode) return;
  try {
    (function() {
    var CACHE_PREFIX = 'headerHeight_';
    var RESIZE_DEBOUNCE_MS = 100;
    var lastWidth = typeof window !== 'undefined' ? window.innerWidth : 0;

    function cacheKey() {
      return CACHE_PREFIX + window.innerWidth + 'x' + window.innerHeight;
    }

    function getHeaderSections() {
      return document.querySelectorAll('.shopify-section-group-header-group');
    }

    function getTransparentSections() {
      return document.querySelectorAll('.section-transparent');
    }

    function measureStructuralHeight() {
      var headerSections = getHeaderSections();
      if (headerSections.length) {
        var total = 0;
        headerSections.forEach(function(section) {
          total += section.offsetHeight;
        });
        return Math.round(total);
      }

      var siteHeader = document.querySelector('.site-header');
      return siteHeader ? Math.round(siteHeader.offsetHeight) : 0;
    }

    function measureVisibleBottom() {
      var headerSections = getHeaderSections();
      if (headerSections.length) {
        var maxBottom = 0;
        headerSections.forEach(function(section) {
          var bottom = section.getBoundingClientRect().bottom;
          if (bottom > maxBottom) maxBottom = bottom;
        });
        return Math.max(0, Math.round(maxBottom));
      }

      var siteHeader = document.querySelector('.site-header');
      return siteHeader ? Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom)) : 0;
    }

    function setVisibleHeight(px) {
      document.documentElement.style.setProperty('--header-height', px + 'px');
    }

    function setStructuralHeight(px) {
      document.documentElement.style.setProperty('--header-height-structural', px + 'px');
    }

    function applyCachedOffset(heightValue, headerHeightPx, showSections) {
      document.documentElement.style.setProperty('--margin-top-header', heightValue);
      setStructuralHeight(headerHeightPx);
      setVisibleHeight(headerHeightPx);
      if (showSections) {
        getTransparentSections().forEach(function(section) {
          section.classList.add('header-offset-ready');
        });
      }
    }

    function recalculate(saveToCache, showSections, updateStructural) {
      var visible = measureVisibleBottom();
      setVisibleHeight(visible);

      if (updateStructural === false) return;

      var structural = measureStructuralHeight();
      if (structural > 0) {
        var heightValue = '-' + structural + 'px';
        document.documentElement.style.setProperty('--margin-top-header', heightValue);
        setStructuralHeight(structural);
        if (showSections) {
          getTransparentSections().forEach(function(section) {
            section.classList.add('header-offset-ready');
          });
        }
        if (saveToCache !== false) {
          try { sessionStorage.setItem(cacheKey(), heightValue); } catch (e) {}
        }
      }
    }

    function onScroll() {
      // Synchronous so pinned-hero USP overlay (top: var(--header-height)) stays
      // flush with the header in the same frame a non-sticky toolbar scrolls away.
      setVisibleHeight(measureVisibleBottom());
    }

    function onResize() {
      var widthChanged = window.innerWidth !== lastWidth;
      lastWidth = window.innerWidth;
      // Mobile URL bar show/hide fires resize with height-only change. Updating
      // structural then reflows homepage hero-pin scroll-track mid-scroll.
      recalculate(true, false, widthChanged);
    }

    function observeHeaderResize() {
      if (typeof ResizeObserver === 'undefined') return;

      var resizeObserver = new ResizeObserver(function() {
        // Header collapse on scroll can fire ResizeObserver; only refresh the
        // live visible offset — keep structural stable for pin geometry.
        recalculate(false, false, false);
      });

      getHeaderSections().forEach(function(section) {
        resizeObserver.observe(section);
      });
    }

    document.addEventListener('DOMContentLoaded', function() {
      lastWidth = window.innerWidth;
      var key = cacheKey();
      var cached;
      try { cached = sessionStorage.getItem(key); } catch (e) {}

      if (cached) {
        applyCachedOffset(cached, Math.abs(parseFloat(cached)), true);
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { recalculate(true, false, true); });
        });
      } else {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { recalculate(true, true, true); });
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      observeHeaderResize();

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(onResize, RESIZE_DEBOUNCE_MS);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["homepage-hero-pin"] && !Shopify.designMode) return;
  try {
    (function() {
    var pinRoot = null;
    var lastWidth = 0;
    var resizeTimer = null;

    function getPinRoot() {
      if (pinRoot && pinRoot.isConnected) return pinRoot;
      pinRoot = document.querySelector('.homepage-hero-pin:has([data-hero-pin])');
      return pinRoot;
    }

    function measureHeaderOffset() {
      var structural = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height-structural')
      );
      if (!isFinite(structural)) structural = 0;

      // Sum every header-group section (toolbar + header). querySelector alone
      // only measures the first section (often just the toolbar).
      var measured = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function(section) {
        measured += section.offsetHeight;
      });
      measured = Math.round(measured);

      if (structural > 0) return Math.round(structural);
      if (measured > 0) return measured;
      return 0;
    }

    /**
     * Prefer layout viewport height at first paint. Avoid visualViewport while
     * scrolling — it changes as mobile browser chrome shows/hides.
     */
    function measureViewportHeight() {
      return Math.round(window.innerHeight || document.documentElement.clientHeight || 0);
    }

    function applyPinGeometry() {
      var root = getPinRoot();
      if (!root) return;

      var viewportH = measureViewportHeight();
      var headerOffset = measureHeaderOffset();
      var trackH = Math.max(0, viewportH - headerOffset);

      root.style.setProperty('--homepage-hero-pin-height', viewportH + 'px');
      root.style.setProperty('--homepage-hero-track-height', trackH + 'px');
      root.style.setProperty('--homepage-hero-header-offset', headerOffset + 'px');
      lastWidth = window.innerWidth;
    }

    function onResize() {
      // Height-only resize = mobile URL bar; ignore to keep pin stable while scrolling.
      if (window.innerWidth === lastWidth) return;
      applyPinGeometry();
    }

    function scheduleResizeCheck() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(onResize, 150);
    }

    function init() {
      if (!document.querySelector('[data-hero-pin]')) return;

      applyPinGeometry();

      // Header calculator may set structural shortly after first paint.
      requestAnimationFrame(function() {
        requestAnimationFrame(applyPinGeometry);
      });
      setTimeout(applyPinGeometry, 100);
      setTimeout(applyPinGeometry, 400);
      setTimeout(applyPinGeometry, 1000);

      window.addEventListener('resize', scheduleResizeCheck, { passive: true });
      window.addEventListener('orientationchange', function() {
        setTimeout(applyPinGeometry, 250);
      }, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
